var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pay',{attrs:{"owners_association":_vm.owners_association,"loading":_vm.loading,"total_amount":_vm.total_amount,"total_amount-show":_vm.total_amountShow,"input":_vm.input},on:{"onPay":_vm.sendPay,"onhandleAmount":_vm.handleAmount}})}
var staticRenderFns = []

export { render, staticRenderFns }